import { createFileRoute } from "@tanstack/react-router";

import { CONTENT_CACHE_CONTROL } from "@/content/cachePolicy";
import FeaturesOverview from "./-components/FeaturesOverview";
import { featureCards } from "./-components/featureSource";

/**
 * The overview. Prerendered like every page of this template, and held by
 * shared caches for the same span the other marketing surfaces are.
 *
 * It loads because the grid it draws is the thirteen pages' own cards and
 * those pages are in the CMS. Its own chrome, the heading and the filter
 * names, stays in `-components/featureTypes.ts`: no document carries it.
 */
export const Route = createFileRoute("/features/")({
  loader: async () => ({ cards: await featureCards() }),
  headers: () => ({ "Cache-Control": CONTENT_CACHE_CONTROL }),
  component: FeaturesOverviewRoute,
});

function FeaturesOverviewRoute() {
  return <FeaturesOverview cards={Route.useLoaderData().cards} />;
}
